import { createContext } from 'react'
import type { UseTwilioChatReturn } from '../types/chat.types'

export const ChatContext = createContext<UseTwilioChatReturn | null>(null)
